<ng-container *ngIf="container">
  <div class="d-flex flex-column gap-4">

    <!-- tab title -->
    <ng-container *ngIf="container?.title?.text && container?.title?.type === 'text'">
      <h5 class="h5 m-0">{{ container?.title.text }}</h5>
    </ng-container>

    <!-- selectedItem should be above the grid -->
    <div
      *ngIf="selectedItem?.type === 'card:video-player'"
      floScrollToElementOnNavigation
      #videoPlayer
      class="border-bottom pb-35"
    >
      <flo-video-player-card [video]="selectedItem"></flo-video-player-card>
    </div>

    <!-- card grid -->
    <div class="card-grid">
      <ng-container *ngFor="let item of container.items; trackBy: trackById">
        <ng-container *ngIf="item.type === 'card'">
          <flo-small-content-card [props]="item" (click)="emitCardClick(item)"></flo-small-content-card>
        </ng-container>

        <!-- infinite scroll -->
        <!-- this should always be at the bottom of this component -->
        <ng-container *ngIf="item.type === 'link' && item.style === 'paginate'">
          <div data-test="grid-container-pagination-spinner" class="d-flex justify-content-center spinner-container">
            <div class="spinner-border text-light"></div>
          </div>
          <div floElementIsVisible [valueToOutput]="item" (elementIsVisible)="emitNextPage($event)" class="col-12">
          </div>
        </ng-container>
      </ng-container>

    </div>
  </div>
</ng-container>